import React, { FC } from 'react';
import MenuItemCore from '../Menu/MenuItemCore';
import { TDropdownItem } from './DropdownCore';

export type TProps = {
  item: Omit<TDropdownItem, 'onClick'>;
} & React.ComponentPropsWithRef<'button'>;

const DropdownItem: FC<TProps> = (props) => {
  const {
    item: { label, icon, selected, ...restItem },
    ...rest
  } = props;

  return (
    <MenuItemCore iconName={icon} isSelected={selected} {...restItem} {...rest}>
      {label}
    </MenuItemCore>
  );
};

export default DropdownItem;
